// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__1JOQq","content":"Modal_content__3qXI4","close":"Modal_close__3_Lqz"};